module.exports = __webpack_public_path__ + "img/binding.64776ce3.png";